// Must be an absolute URL to the API host, matching every other endpoint in
// this app (see src/config/api.js) — the frontend is a separate Azure Static
// Web App with no real backend behind its own /api/*, so a relative path
// here resolves against the wrong origin and 405s instead of reaching this
// telemetry route.
const DEFAULT_ENDPOINT = `${(
  process.env.REACT_APP_API_URL || 'https://backend-clinical-intake.dizzaroo.com'
).replace(/\/$/, '')}/api/telemetry/events`;

function nowMs() {
  // performance.now() is monotonic and ideal for durations.
  if (typeof performance !== 'undefined' && performance.now) return performance.now();
  return Date.now();
}

const spans = new Map();

export function startSpan(metric, { page = 'unknown', meta = {} } = {}) {
  if (!metric) return;
  spans.set(metric, { t0: nowMs(), page, meta });
}

export async function endSpan(metric, { status = 'ok' } = {}) {
  const span = spans.get(metric);
  if (!span) return;
  spans.delete(metric);
  const durationMs = Math.max(0, nowMs() - span.t0);
  await emitEvent({
    metric,
    page: span.page,
    status,
    durationMs,
    meta: span.meta,
  });
}

export async function emitEvent({ metric, page = 'unknown', status = 'ok', durationMs, meta } = {}) {
  try {
    const payload = {
      metric: String(metric || 'unknown'),
      page: String(page || 'unknown'),
      status: String(status || 'ok'),
      durationMs: typeof durationMs === 'number' ? durationMs : undefined,
      meta: meta && typeof meta === 'object' ? meta : undefined,
      ts: new Date().toISOString(),
    };

    // Prefer sendBeacon to avoid blocking UI/navigation; fall back to fetch.
    if (navigator?.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(DEFAULT_ENDPOINT, blob);
      return;
    }

    await fetch(DEFAULT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // Telemetry must never break the app.
  }
}

